import UserInformation from 'assets/images/sidebar/userInformation.svg'
import Asset from 'assets/images/sidebar/asset.svg'
import AccountNumber from 'assets/images/sidebar/accountNumber.svg'
import IdentificationCode from 'assets/images/sidebar/identificationCode.svg'
import Settings from 'assets/images/sidebar/settings.svg'
import ContactSupport from 'assets/images/sidebar/cuntactSupport.svg'
import SocialMedia from 'assets/images/sidebar/socialMedia.svg'
import Rools from 'assets/images/sidebar/rools.svg'
import Guide from 'assets/images/sidebar/guide.svg'
import Share from 'assets/images/sidebar/share.svg'
import Questions from 'assets/images/sidebar/questions.svg'
import Star from 'assets/images/sidebar/Star.svg'
import AboutUs from 'assets/images/sidebar/aboutUs.svg'
import Exit from 'assets/images/sidebar/exit.svg'
interface ISidebarItemsProps {
    id: number
    icon: string
    text: string
    isDisable: boolean
    route: string
}
export const sideBarItems: Array<ISidebarItemsProps> = [
    {
        id: 0,
        icon: UserInformation,
        text: 'اطلاعات کاربری',
        isDisable: false,
        route: '/account/profile',
    },
    {
        id: 1,
        icon: Asset,
        text: 'کیف پول',
        isDisable: true,
        route: '/wallet',
    },
    {
        id: 2,
        icon: AccountNumber,
        text: 'مدیریت کارت‌های بانکی',
        isDisable: true,
        route: '/manage-bank-cards',
    },
    {
        id: 3,
        icon: IdentificationCode,
        text: 'کد معرف',
        isDisable: true,
        route: '/',
    },
    {
        id: 12,
        icon: Star,
        text: 'ثبت بازخورد',
        isDisable: true,
        route: '/',
    },
    {
        id: 4,
        icon: Settings,
        text: 'تنظیمات',
        isDisable: true,
        route: '/',
    },
    {
        id: 5,
        icon: ContactSupport,
        text: 'تماس با پشتیبانی',
        isDisable: false,
        route: '/',
    },
    {
        id: 11,
        icon: SocialMedia,
        text: 'همیان در شبکه‌های اجتماعی',
        isDisable: false,
        route: '/',
    },
    {
        id: 10,
        icon: Questions,
        text: 'سوالات متداول',
        isDisable: true,
        route: '/',
    },
    {
        id: 14,
        icon: AboutUs,
        text: 'درباره‌ی ما',
        isDisable: true,
        route: '/',
    },
    {
        id: 7,
        icon: Rools,
        text: 'قوانین و مقررات',
        isDisable: true,
        route: '/',
    },
    {
        id: 8,
        icon: Guide,
        text: 'راهنمای استفاده از اپلیکیشن',
        isDisable: true,
        route: '/',
    },
    {
        id: 9,
        icon: Share,
        text: 'اشتراک‌گذاری برنامه',
        isDisable: true,
        route: '/',
    },
    {
        id: 13,
        icon: Exit,
        text: 'خروج از حساب‌کاربری',
        isDisable: false,
        route: '/home',
    },
]
